import React from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";

const SpeedometerButton = ({ children, onClick }) => {
  return (
    <Box
      sx={{
        width: 150,
        height: 150,
        marginBottom: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        backgroundColor: "#eee",
        "&:hover": {
          backgroundColor: "#ddd",
          opacity: [0.9, 0.8, 0.7],
        },
      }}
      onClick={onClick}
    >
      <Stack direction="row" spacing={2}>
        {children}
      </Stack>
    </Box>
  );
};
export default SpeedometerButton;
